export const lang = {
	ACTIVE_PLAN: {
		MAIN: 'You have an Active Plan, which includes:',
		LIFETIME_PLAN: 'Your plan is a lifetime plan.',
		NOT_LIFETIME_PLAN: 'Your plan will expire on '
	},
	ACTIVE_SUBSCRIPTION: {
		MAIN: 'You have an Active Subscription, which includes:',
		LIFETIME_PLAN: 'Your plan is a lifetime plan.'
	},
	NO_ACTIVE_PLAN: "You don't have an Active Plan.",
	FAILED_SUBSCRIPTION: 'The recurring bill on your subscription has failed.',
	PAST_DUE_SUBSCRIPTION:
		"You don't have an active subscription, because previous billing attempts failed.",
	CANCELLED_SUBSCRIPTION: 'Your subscription has been cancelled.',
	INVALID_PAYMENT_PLAN: 'Invalid payment plan status',
	CAMP_MESSAGE: {
		MAIN: 'You are a camp instructor - you can access the product without an active plan.'
	}
};
